import React from 'react';
import '../style/OfferSection.scss';

const OfferSection = () => {
  const services = [
    { 
      icon: '/OfferSection/web-design.png', 
      title: 'Web Design', 
      description: 'We create aesthetically pleasing and responsive websites that ensure an exceptional user experience across all devices, helping your brand make a lasting impression.' 
    },
    { 
      icon: '/OfferSection/programming.png', 
      title: 'Web Development', 
      description: 'Our team builds high-performance websites with cutting-edge technologies, ensuring speed, scalability, and custom features that fit your unique business needs.' 
    },
    { 
      icon: '/OfferSection/settings.png', 
      title: 'Web Maintenance', 
      description: 'We provide continuous support and monitoring, ensuring your website remains secure, up-to-date, and free of issues, so you can focus on growing your business.' 
    },
    { 
      icon: '/OfferSection/consulting-services.png', 
      title: 'Web Consulting', 
      description: 'Our expert consultants help you define your digital strategy, offering advice on technology selection and practical solutions to optimize your online presence.' 
    },
    { 
      icon: '/OfferSection/seo.png', 
      title: 'SEO', 
      description: 'We enhance your website’s visibility through advanced SEO strategies, helping you rank higher on search engines, attract more visitors, and increase conversions.' 
    },
    { 
      icon: '/OfferSection/social-media.png', 
      title: 'Social Media', 
      description: 'We manage your social media platforms with engaging content, building a strong online community that connects with your audience and strengthens your brand.' 
    },
    { 
      icon: '/OfferSection/creative-writing.png', 
      title: 'Creative Content', 
      description: 'We create captivating videos and visuals, from promotional ads to social media content, to tell your brand’s story and engage your audience effectively.' 
    }
  ];

  return (
    <section className='Offer-Section'>
      <div className="site-heading-Offer">
        <h2>What we <span>Offer</span></h2>
        <h4>At <span>EVAS</span>, we provide custom web design solutions that combine elegance and functionality. We focus on crafting visually appealing websites while enhancing user engagement and experience.</h4>

      </div>
      <div className="row-Offer">
        {services.map((service, index) => (
          <div className="column-Offer" key={index}>
            <div className="card-Offer">
              <div className="icon-wrapper">
      
                <img src={service.icon} alt={service.title} />
              </div>
            
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OfferSection;
